import {Component} from '@angular/core';

@Component({
  selector: 'app-custom-loading',
  styleUrls: ['./custom-loading.component.scss'],
  templateUrl: './custom-loading.component.html'
})
export class CustomLoadingComponent {
  constructor() {
  }
}
